import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// ACTIONS
const GET_DISTRIBUTION_DATA =
  'luft/operational-dashboard-distribution/GET_DISTRIBUTION_DATA';
const GET_DISTRIBUTION_DATA_SUCCESS =
  'luft/operational-dashboard-distribution/GET_DISTRIBUTION_DATA_SUCCESS';
const GET_DISTRIBUTION_DATA_FAILURE =
  'luft/operational-dashboard-distribution/GET_DISTRIBUTION_DATA_FAILURE';

// REDUCER
const INITIAL_STATE = {
  isFetching: false,
  error: false,
  data: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DISTRIBUTION_DATA:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case GET_DISTRIBUTION_DATA_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
      };
    case GET_DISTRIBUTION_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// ACTION CREATORS
const _getDistributionData = () => ({
  type: GET_DISTRIBUTION_DATA,
});
const _getDistributionDataSuccess = data => ({
  type: GET_DISTRIBUTION_DATA_SUCCESS,
  data,
});
const _getDistributionDataFailure = error => ({
  type: GET_DISTRIBUTION_DATA_FAILURE,
  error,
});

// THUNK ACTION CREATORS
export const getDistributionData = searchParams => async dispatch => {
  dispatch(_getDistributionData());
  try {
    const response = await luftGet(
      '/DashboardOperational/Distribution',
      searchParams,
    );
    dispatch(_getDistributionDataSuccess(response.data));
  } catch (error) {
    loggedUserRequestErrorHandler(
      dispatch,
      error,
      _getDistributionDataFailure(error.message),
    );
  }
};
